import { DISHWASHER_OPTIONS, SortDishwasherBy } from '@common/enums';
import { Filter } from '@common/models';
import { RootState } from '@redux/store';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

type DishwasherId = number;

export type DishwasherFilters = Record<string, Filter>;

interface DishwasherState {
    // TODO: Rename to dishwashersById
    selectedDishwasherId?: DishwasherId;
    dishwasherSelectedOption?: DISHWASHER_OPTIONS;
    dishwasherFilters?: DishwasherFilters;
    sortBy?: SortDishwasherBy;
}

const initialState: DishwasherState = {
    selectedDishwasherId: undefined,
    dishwasherSelectedOption: undefined,
    dishwasherFilters: undefined,
    sortBy: SortDishwasherBy.HighToLow,
};

const dishwasherSlice = createSlice({
    name: 'dishwasher',
    initialState,
    reducers: {
        updateSelectedDishwasherId: (state, action: PayloadAction<DishwasherId>) => {
            state.selectedDishwasherId = action.payload;
        },
        updateDishwasherSelectedOption: (state, action: PayloadAction<DISHWASHER_OPTIONS | undefined>) => {
            state.dishwasherSelectedOption = action.payload;
        },
        updateDishwasherFilters: (state, action: PayloadAction<DishwasherFilters>) => {
            state.dishwasherFilters = action.payload;
        },
        resetDishwashers: (state) => {
            state.dishwasherFilters = initialState.dishwasherFilters;
            state.dishwasherSelectedOption = initialState.dishwasherSelectedOption;
        },
        updateDishwashersSortBy: (state, action: PayloadAction<SortDishwasherBy | undefined>) => {
            state.sortBy = action.payload;
        },
    },
});

export const {
    updateSelectedDishwasherId,
    updateDishwasherSelectedOption,
    updateDishwasherFilters,
    resetDishwashers,
    updateDishwashersSortBy,
} = dishwasherSlice.actions;

export default dishwasherSlice.reducer;

export const selectSelectedDishwasherId = ({ dishwasher }: RootState): DishwasherId | undefined => {
    return dishwasher.selectedDishwasherId;
};

export const selectDishwasherSelectedOption = ({ dishwasher }: RootState): DISHWASHER_OPTIONS | undefined =>
    dishwasher.dishwasherSelectedOption;

export const selectDishwasherFilters = ({ dishwasher }: RootState): DishwasherFilters | undefined =>
    dishwasher.dishwasherFilters;

export const selectDishwasherSortBy = ({ dishwasher }: RootState): SortDishwasherBy | undefined => dishwasher.sortBy;
